webpackJsonp([4],{

/***/ "+PJt":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = __webpack_require__("bOnR");
module.exports = exports['default'];

/***/ }),

/***/ "0Jhu":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = __webpack_require__("HNDM");
module.exports = exports['default'];

/***/ }),

/***/ "BuYh":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = __webpack_require__("vP8h");
module.exports = exports['default'];

/***/ }),

/***/ "ClnW":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = __webpack_require__("D6ya");
module.exports = exports['default'];

/***/ }),

/***/ "D6ya":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _dec, _class;

var _react = __webpack_require__("CwoH");

var _react2 = _interopRequireDefault(_react);

var _acastReactor = __webpack_require__("5Pd1");

var _base = __webpack_require__("L/cF");

var _base2 = _interopRequireDefault(_base);

var _divider = __webpack_require__("khXA");

var _divider2 = _interopRequireDefault(_divider);

var _delayedInput = __webpack_require__("1mPs");

var _delayedInput2 = _interopRequireDefault(_delayedInput);

var _loader = __webpack_require__("lcFn");

var _loader2 = _interopRequireDefault(_loader);

var _hero = __webpack_require__("BuYh");

var _hero2 = _interopRequireDefault(_hero);

var _learnMore = __webpack_require__("0Jhu");

var _learnMore2 = _interopRequireDefault(_learnMore);

var _getApp = __webpack_require__("bJQW");

var _getApp2 = _interopRequireDefault(_getApp);

var _searchModule = __webpack_require__("hJI4");

var _searchModule2 = _interopRequireDefault(_searchModule);

var _gridLandingModule = __webpack_require__("+PJt");

var _gridLandingModule2 = _interopRequireDefault(_gridLandingModule);

var _strings = __webpack_require__("ky58");

var _strings2 = _interopRequireDefault(_strings);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var LandingView = (_dec = _acastReactor.Query.inject(function (props) {
  return {
    query: _acastReactor.Query.run('GetCuratedContent', 'Landing')
  };
}), _dec(_class = function (_Base) {
  _inherits(LandingView, _Base);

  function LandingView(props) {
    _classCallCheck(this, LandingView);

    return _possibleConstructorReturn(this, (LandingView.__proto__ || Object.getPrototypeOf(LandingView)).call(this, props));
  }

  _createClass(LandingView, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        { className: 'view-landing' },
        _react2.default.createElement(_hero2.default, null),
        _react2.default.createElement(_divider2.default, null),
        this.modules,
        _react2.default.createElement(_learnMore2.default, null),
        _react2.default.createElement(_getApp2.default, null)
      );
    }
  }, {
    key: 'modules',
    get: function get() {
      var query = this.props.query;

      if (query.isComplete && !query.error && query.value && query.value.modules) {
        var data = query.value.modules;
        var result = [];

        data.forEach(function (module, key) {
          switch (module.type.toLowerCase()) {
            case 'hero':
              result.push(_react2.default.createElement(_hero2.default, { key: key, module: module }));
              break;

            case 'grid':
              result.push(_react2.default.createElement(_gridLandingModule2.default, { key: key, module: module }));
              break;

            case 'horizontallist':
              result.push(_react2.default.createElement(HorizontalList, { key: key, module: module }));
              break;

            case 'categories':
              result.push(_react2.default.createElement(Categories, { key: key, module: module }));
              break;

            case 'trending':
              result.push(_react2.default.createElement(Trending, { key: key, module: module }));
              break;

            case 'search':
              result.push(_react2.default.createElement(_searchModule2.default, { key: key, module: module }));
              break;

            default:
              console.log('LandingView.get.modules: ' + module.type + ' is an unsupported module type');
          }
        });

        return result;
      } else if (query.error) {
        return _react2.default.createElement(
          'div',
          { style: { display: 'none' } },
          'JSON.stringify(query.error)'
        );
      } else {
        var style = {};
        if (typeof window !== 'undefined') {
          style.height = window.innerHeight - 745 + 'px';
        }
        return _react2.default.createElement(_loader2.default, { style: style });
      }
    }
  }]);

  return LandingView;
}(_base2.default)) || _class);
exports.default = LandingView;
module.exports = exports['default'];

/***/ }),

/***/ "HNDM":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("CwoH");

var _react2 = _interopRequireDefault(_react);

var _base = __webpack_require__("L/cF");

var _base2 = _interopRequireDefault(_base);

var _strings = __webpack_require__("ky58");

var _strings2 = _interopRequireDefault(_strings);

var _buttonRounded = __webpack_require__("FfqD");

var _buttonRounded2 = _interopRequireDefault(_buttonRounded);

var _baseUrl = __webpack_require__("V26w");

var _baseUrl2 = _interopRequireDefault(_baseUrl);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var LearnMore = function (_Base) {
  _inherits(LearnMore, _Base);

  function LearnMore() {
    _classCallCheck(this, LearnMore);

    return _possibleConstructorReturn(this, (LearnMore.__proto__ || Object.getPrototypeOf(LearnMore)).call(this));
  }

  _createClass(LearnMore, [{
    key: 'render',
    value: function render() {
      var rootClassName = this.css({});

      var wrapperClassName = this.css({ base: 'content' });

      var imageClassName = this.css({
        base: 'learn-more-image',
        compose: ['column']
      });

      var puffClassName = this.css({
        base: 'learn-more-puff',
        compose: ['column', 'copy-content']
      });

      var buttonContClassName = this.css({ base: 'button-container' });

      return _react2.default.createElement(
        'section',
        { className: rootClassName },
        _react2.default.createElement(
          'div',
          { className: wrapperClassName },
          _react2.default.createElement(
            'div',
            { className: puffClassName },
            _react2.default.createElement(
              'h1',
              null,
              _strings2.default.get('home.learnMore.title')
            ),
            _react2.default.createElement(
              'p',
              null,
              _strings2.default.get('home.learnMore.body')
            ),
            _react2.default.createElement(
              'p',
              null,
              _react2.default.createElement(
                'strong',
                null,
                _strings2.default.get('home.learnMore.dive')
              )
            ),
            _react2.default.createElement(
              'p',
              null,
              _react2.default.createElement(
                'strong',
                null,
                _strings2.default.get('home.learnMore.extra')
              )
            ),
            _react2.default.createElement(
              'div',
              { className: buttonContClassName },
              _react2.default.createElement(
                _buttonRounded2.default,
                { variant: '', linkTo: _baseUrl2.default + 'about' },
                _strings2.default.get('home.learnMore.learnMore')
              )
            )
          )
        )
      );
    }
  }]);

  return LearnMore;
}(_base2.default);

exports.default = LearnMore;
module.exports = exports['default'];

/***/ }),

/***/ "Rg4+":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _desc, _value, _class;

var _react = __webpack_require__("CwoH");

var _react2 = _interopRequireDefault(_react);

var _autobindDecorator = __webpack_require__("1oPu");

var _autobindDecorator2 = _interopRequireDefault(_autobindDecorator);

var _base = __webpack_require__("L/cF");

var _base2 = _interopRequireDefault(_base);

var _strings = __webpack_require__("ky58");

var _strings2 = _interopRequireDefault(_strings);

var _buttonRounded = __webpack_require__("FfqD");

var _buttonRounded2 = _interopRequireDefault(_buttonRounded);

var _channelCover = __webpack_require__("hDq6");

var _channelCover2 = _interopRequireDefault(_channelCover);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

var ChannelGrid = (_class = function (_Base) {
  _inherits(ChannelGrid, _Base);

  function ChannelGrid(props) {
    _classCallCheck(this, ChannelGrid);

    var _this = _possibleConstructorReturn(this, (ChannelGrid.__proto__ || Object.getPrototypeOf(ChannelGrid)).call(this, props));

    _this.state = {
      css: {
        height: '0px'
      },
      currentlyHovering: 0
    };
    return _this;
  }

  _createClass(ChannelGrid, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      window.addEventListener('resize', this.onResize);
      this.onResize();
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      window.removeEventListener('resize', this.onResize);
    }
  }, {
    key: 'onResize',
    value: function onResize() {
      var grid = document.getElementsByClassName('channel-grid');
      var height = grid[0].clientWidth / 2;
      this.setState({
        css: {
          height: height + 'px'
        }
      });
    }
  }, {
    key: 'onHover',
    value: function onHover(e) {
      if (e && e.currentTarget) {
        this.setState({
          currentlyHovering: parseInt(e.currentTarget.id)
        });
      }
    }
  }, {
    key: 'getZIndex',
    value: function getZIndex(channelIndex) {
      if (channelIndex === this.state.currentlyHovering) {
        return {
          zIndex: 1000
        };
      } else {
        return {
          zIndex: 0
        };
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var channels = this.props.channels;
      var has2rows = 'rows' in this.props && this.props.rows == 2;
      var gridStyle = this.state.css;

      var firstRow = _react2.default.createElement(
        'div',
        { className: 'row', style: gridStyle },
        _react2.default.createElement(_channelCover2.default, {
          id: '0',
          onMouseOver: this.onHover,
          model: channels[0],
          showInfo: 'true',
          addClassName: 'col',
          style: this.getZIndex(0)
        }),
        _react2.default.createElement(
          'div',
          { className: 'col' },
          _react2.default.createElement(
            'div',
            { className: 'row' },
            _react2.default.createElement(_channelCover2.default, {
              id: '1',
              onMouseOver: this.onHover,
              model: channels[1],
              showInfo: 'true',
              addClassName: 'col channel-cover-small',
              style: this.getZIndex(1)
            }),
            _react2.default.createElement(_channelCover2.default, {
              id: '2',
              onMouseOver: this.onHover,
              model: channels[2],
              showInfo: 'true',
              addClassName: 'col channel-cover-small',
              style: this.getZIndex(2)
            })
          ),
          _react2.default.createElement(
            'div',
            { className: 'row' },
            _react2.default.createElement(_channelCover2.default, {
              id: '3',
              onMouseOver: this.onHover,
              model: channels[3],
              showInfo: 'true',
              addClassName: 'col channel-cover-small',
              style: this.getZIndex(3)
            }),
            _react2.default.createElement(_channelCover2.default, {
              id: '4',
              onMouseOver: this.onHover,
              model: channels[4],
              showInfo: 'true',
              addClassName: 'col channel-cover-small',
              style: this.getZIndex(4)
            })
          )
        )
      );

      var secondRow = '';
      if (has2rows) {
        secondRow = _react2.default.createElement(
          'div',
          { className: 'row', style: gridStyle },
          _react2.default.createElement(
            'div',
            { className: 'col' },
            _react2.default.createElement(
              'div',
              { className: 'row' },
              _react2.default.createElement(_channelCover2.default, {
                id: '5',
                onMouseOver: this.onHover,
                model: channels[5],
                showInfo: 'true',
                addClassName: 'col channel-cover-small',
                style: this.getZIndex(5)
              }),
              _react2.default.createElement(_channelCover2.default, {
                id: '6',
                onMouseOver: this.onHover,
                model: channels[6],
                showInfo: 'true',
                addClassName: 'col channel-cover-small',
                style: this.getZIndex(6)
              })
            ),
            _react2.default.createElement(
              'div',
              { className: 'row' },
              _react2.default.createElement(_channelCover2.default, {
                id: '7',
                onMouseOver: this.onHover,
                model: channels[7],
                showInfo: 'true',
                addClassName: 'col channel-cover-small',
                style: this.getZIndex(7)
              }),
              _react2.default.createElement(_channelCover2.default, {
                id: '8',
                onMouseOver: this.onHover,
                model: channels[8],
                showInfo: 'true',
                addClassName: 'col channel-cover-small',
                style: this.getZIndex(8)
              })
            )
          ),
          _react2.default.createElement(_channelCover2.default, {
            id: '9',
            onMouseOver: this.onHover,
            model: channels[9],
            showInfo: 'true',
            addClassName: 'col',
            style: this.getZIndex(9)
          })
        );
      }

      return _react2.default.createElement(
        'div',
        { className: this.css() },
        firstRow,
        secondRow
      );
    }
  }]);

  return ChannelGrid;
}(_base2.default), (_applyDecoratedDescriptor(_class.prototype, 'onResize', [_autobindDecorator2.default], Object.getOwnPropertyDescriptor(_class.prototype, 'onResize'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'onHover', [_autobindDecorator2.default], Object.getOwnPropertyDescriptor(_class.prototype, 'onHover'), _class.prototype)), _class);
exports.default = ChannelGrid;
module.exports = exports['default'];

/***/ }),

/***/ "bJQW":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = __webpack_require__("fxXl");
module.exports = exports['default'];

/***/ }),

/***/ "bOnR":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _desc, _value, _class;

var _react = __webpack_require__("CwoH");

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__("NKHc");

var _autobindDecorator = __webpack_require__("1oPu");

var _autobindDecorator2 = _interopRequireDefault(_autobindDecorator);

var _strings = __webpack_require__("ky58");

var _strings2 = _interopRequireDefault(_strings);

var _base = __webpack_require__("L/cF");

var _base2 = _interopRequireDefault(_base);

var _channelGrid = __webpack_require__("wQ2X");

var _channelGrid2 = _interopRequireDefault(_channelGrid);

var _channelList = __webpack_require__("6TFs");

var _channelList2 = _interopRequireDefault(_channelList);

var _buttonRounded = __webpack_require__("FfqD");

var _buttonRounded2 = _interopRequireDefault(_buttonRounded);

var _loader = __webpack_require__("lcFn");

var _loader2 = _interopRequireDefault(_loader);

var _baseUrl = __webpack_require__("V26w");

var _baseUrl2 = _interopRequireDefault(_baseUrl);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

var BREAKPOINT = 750; // when to switch to mobile

var GridLandingModule = (_class = function (_Base) {
  _inherits(GridLandingModule, _Base);

  _createClass(GridLandingModule, null, [{
    key: 'propTypes',
    get: function get() {
      return {
        module: _react2.default.PropTypes.object.isRequired
      };
    }
  }]);

  function GridLandingModule(props) {
    _classCallCheck(this, GridLandingModule);

    var _this = _possibleConstructorReturn(this, (GridLandingModule.__proto__ || Object.getPrototypeOf(GridLandingModule)).call(this, props));

    _this.state = {
      screenWidth: 300
    };
    return _this;
  }

  _createClass(GridLandingModule, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      window.addEventListener('resize', this.onResize);
      this.onResize();
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      window.removeEventListener('resize', this.onResize);
    }
  }, {
    key: 'onResize',
    value: function onResize() {
      var element = (0, _reactDom.findDOMNode)(this.refs.container);
      if (element) {
        this.setState({
          screenWidth: element.getBoundingClientRect().width
        });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      if (this.props.module.children.length) {
        var tagClasses = this.css({
          base: 'section-tag',
          compose: ['text-color2']
        });

        var titleClass = this.css({
          base: 'section-title',
          compose: ['text-color4']
        });

        var channels = null;
        if (this.state.screenWidth > BREAKPOINT) {
          channels = _react2.default.createElement(_channelGrid2.default, {
            addClassName: 'channel-grid-raised',
            rows: this.props.module.children.length > 9 ? 2 : 1,
            channels: this.props.module.children
          });
        } else {
          channels = _react2.default.createElement(_channelList2.default, {
            numberOfCols: 5,
            numberOfRows: 1,
            itemWidth: 245,
            itemHeight: 220,
            channels: this.props.module.children
          });
        }

        return _react2.default.createElement(
          'section',
          { ref: 'container', className: this.css() },
          _react2.default.createElement(
            'div',
            { className: 'channel-container' },
            channels
          ),
          _react2.default.createElement(
            'div',
            { className: 'content' },
            _react2.default.createElement(
              'div',
              { className: 'discover-more-button' },
              _react2.default.createElement(
                _buttonRounded2.default,
                { linkTo: _baseUrl2.default + 'discover' },
                _strings2.default.get('home.staffPicks.discover')
              )
            )
          )
        );
      } else {
        return _react2.default.createElement(
          'div',
          { style: { display: 'none' } },
          'No Channels Supplied'
        );
      }
    }
  }]);

  return GridLandingModule;
}(_base2.default), (_applyDecoratedDescriptor(_class.prototype, 'onResize', [_autobindDecorator2.default], Object.getOwnPropertyDescriptor(_class.prototype, 'onResize'), _class.prototype)), _class);
exports.default = GridLandingModule;
module.exports = exports['default'];

/***/ }),

/***/ "fxXl":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("CwoH");

var _react2 = _interopRequireDefault(_react);

var _base = __webpack_require__("L/cF");

var _base2 = _interopRequireDefault(_base);

var _strings = __webpack_require__("ky58");

var _strings2 = _interopRequireDefault(_strings);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var GetApp = function (_Base) {
  _inherits(GetApp, _Base);

  function GetApp() {
    _classCallCheck(this, GetApp);

    return _possibleConstructorReturn(this, (GetApp.__proto__ || Object.getPrototypeOf(GetApp)).call(this));
  }

  _createClass(GetApp, [{
    key: 'render',
    value: function render() {
      var view = this.props && this.props.view ? this.props.view : 'home';

      return _react2.default.createElement(
        'section',
        { id: 'getapp', className: this.css() },
        _react2.default.createElement(
          'div',
          { className: 'content' },
          _react2.default.createElement(
            'div',
            { className: 'get-app-puff copy-content' },
            _react2.default.createElement(
              'h1',
              null,
              _strings2.default.get(view + '.getApp.title')
            ),
            _react2.default.createElement(
              'p',
              null,
              _strings2.default.get(view + '.getApp.body')
            ),
            _react2.default.createElement(
              'div',
              { className: 'button-container' },
              _react2.default.createElement(
                'a',
                {
                  href: 'https://itunes.apple.com/app/acast-podcast-player/id925311796',
                  target: '_blank'
                },
                _react2.default.createElement('img', {
                  className: 'button-app-store',
                  src: 'https://cdn.acast.com/images/icons/icon-app-store.svg'
                })
              ),
              _react2.default.createElement(
                'a',
                {
                  href: 'https://play.google.com/store/apps/details?id=com.acast.nativeapp',
                  target: '_blank'
                },
                _react2.default.createElement('img', {
                  className: 'button-google-play',
                  src: 'https://cdn.acast.com/images/icons/icon-google-play-2.png'
                })
              ),
              _react2.default.createElement(
                'a',
                {
                  href: 'https://www.microsoft.com/en-us/store/p/acast/9nblggh4np8f',
                  target: '_blank'
                },
                _react2.default.createElement('img', {
                  className: 'button-microsoft-store',
                  src: 'https://cdn.acast.com/images/icons/icon-microsoft-store.png'
                })
              )
            )
          ),
          _react2.default.createElement('div', { className: 'get-app-image' })
        )
      );
    }
  }]);

  return GetApp;
}(_base2.default);

exports.default = GetApp;
module.exports = exports['default'];

/***/ }),

/***/ "hJI4":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = __webpack_require__("zj94");
module.exports = exports['default'];

/***/ }),

/***/ "vP8h":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _desc, _value, _class;

var _react = __webpack_require__("CwoH");

var _react2 = _interopRequireDefault(_react);

var _autobindDecorator = __webpack_require__("1oPu");

var _autobindDecorator2 = _interopRequireDefault(_autobindDecorator);

var _base = __webpack_require__("L/cF");

var _base2 = _interopRequireDefault(_base);

var _strings = __webpack_require__("ky58");

var _strings2 = _interopRequireDefault(_strings);

var _buttonRounded = __webpack_require__("FfqD");

var _buttonRounded2 = _interopRequireDefault(_buttonRounded);

var _baseUrl = __webpack_require__("V26w");

var _baseUrl2 = _interopRequireDefault(_baseUrl);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

var HomeHero = (_class = function (_Base) {
  _inherits(HomeHero, _Base);

  function HomeHero(props) {
    _classCallCheck(this, HomeHero);

    var _this = _possibleConstructorReturn(this, (HomeHero.__proto__ || Object.getPrototypeOf(HomeHero)).call(this, props));

    _this.state = {
      css: {
        height: '0px'
      }
    };

    _this.onResize = _this.onResize.bind(_this);
    return _this;
  }

  _createClass(HomeHero, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      window.addEventListener('resize', this.onResize);
      this.onResize();
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      window.removeEventListener('resize', this.onResize);
    }
  }, {
    key: 'onResize',
    value: function onResize() {
      return;
      this.setState({
        css: {
          height: window.innerHeight - 94 + 'px'
        }
      });
    }
  }, {
    key: 'onGetApp',
    value: function onGetApp() {
      var element = document.getElementById('getapp');
      if (element) {
        element.scrollIntoView();
      }
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'section',
        { className: this.css(), style: this.state.css },
        _react2.default.createElement(
          'div',
          { className: 'content' },
          _react2.default.createElement(
            'div',
            { className: 'body' },
            _react2.default.createElement(
              'h1',
              null,
              _strings2.default.get('home.hero.title')
            ),
            _strings2.default.get('home.hero.body'),
            _react2.default.createElement(
              _buttonRounded2.default,
              { onClick: this.onGetApp, variant: 'button-rounded-yellow' },
              _strings2.default.get('home.hero.getApp')
            ),
            _react2.default.createElement(
              _buttonRounded2.default,
              { linkTo: _baseUrl2.default + 'discover' },
              _strings2.default.get('home.hero.listen')
            )
          )
        )
      );
    }
  }]);

  return HomeHero;
}(_base2.default), (_applyDecoratedDescriptor(_class.prototype, 'onGetApp', [_autobindDecorator2.default], Object.getOwnPropertyDescriptor(_class.prototype, 'onGetApp'), _class.prototype)), _class);
exports.default = HomeHero;
module.exports = exports['default'];

/***/ }),

/***/ "wQ2X":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = __webpack_require__("Rg4+");
module.exports = exports['default'];

/***/ }),

/***/ "zj94":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _desc, _value, _class;

var _react = __webpack_require__("CwoH");

var _react2 = _interopRequireDefault(_react);

var _autobindDecorator = __webpack_require__("1oPu");

var _autobindDecorator2 = _interopRequireDefault(_autobindDecorator);

var _base = __webpack_require__("L/cF");

var _base2 = _interopRequireDefault(_base);

var _delayedInput = __webpack_require__("1mPs");

var _delayedInput2 = _interopRequireDefault(_delayedInput);

var _search = __webpack_require__("dPRq");

var _search2 = _interopRequireDefault(_search);

var _strings = __webpack_require__("ky58");

var _strings2 = _interopRequireDefault(_strings);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

var SearchModule = (_class = function (_Base) {
  _inherits(SearchModule, _Base);

  function SearchModule() {
    _classCallCheck(this, SearchModule);

    var _this = _possibleConstructorReturn(this, (SearchModule.__proto__ || Object.getPrototypeOf(SearchModule)).call(this));

    _this.state = {
      query: null,
      isSearching: false
    };
    return _this;
  }

  _createClass(SearchModule, [{
    key: 'onUpdate',
    value: function onUpdate(e) {
      this.setState({
        query: e.value
      });
    }
  }, {
    key: 'onSearchStart',
    value: function onSearchStart() {
      this.setState({
        isSearching: true
      });
    }
  }, {
    key: 'onSearchEnd',
    value: function onSearchEnd() {
      this.setState({
        isSearching: false
      });
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'section',
        { className: this.css({ searching: this.state.isSearching }) },
        _react2.default.createElement(
          'div',
          { className: 'content' },
          _react2.default.createElement(
            'div',
            { className: 'search-field-wrapper' },
            _react2.default.createElement(_delayedInput2.default, {
              placeholder: _strings2.default.get('common.searchPlaceholder'),
              className: 'search-field',
              onUpdate: this.onUpdate,
              type: 'text'
            }),
            _react2.default.createElement('div', { className: 'loader' })
          )
        ),
        _react2.default.createElement(_search2.default, {
          query: this.state.query,
          fieldClassName: 'search-field',
          onSearchStart: this.onSearchStart,
          onSearchEnd: this.onSearchEnd
        })
      );
    }
  }]);

  return SearchModule;
}(_base2.default), (_applyDecoratedDescriptor(_class.prototype, 'onUpdate', [_autobindDecorator2.default], Object.getOwnPropertyDescriptor(_class.prototype, 'onUpdate'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'onSearchStart', [_autobindDecorator2.default], Object.getOwnPropertyDescriptor(_class.prototype, 'onSearchStart'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'onSearchEnd', [_autobindDecorator2.default], Object.getOwnPropertyDescriptor(_class.prototype, 'onSearchEnd'), _class.prototype)), _class);
exports.default = SearchModule;
module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// 741162ae80a522f43e9a-4.min.js